export default __webpack_public_path__ + "static/media/Mark-2-HUD-3D (Environmental Scan).9a047341.jpg";